<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getShippingInsurances.length > 0 && $store.getters.getShippingInsurancesLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'shippingInsurances_Id',
            'shippingInsurances_ForbiddenGoodsKeyword',
            'shippingInsurances_Status',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('shippingInsurances_Id.localization_value.value') }}</th>
            <th>{{ $t('shippingInsurances_country.localization_value.value') }}</th>
            <th>{{ $t('shippingInsurances_price.localization_value.value') }}</th>
            <th>{{ $t('shippingInsurances_name.localization_value.value') }}</th>
            <th>{{ $t('shippingInsurances_shippingCompany.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getShippingInsurances" :key="index">
            <td>
              #{{item.id}}
            </td>
            <td>
              <ValueHelper
                      :value="item.country"
              />
            </td>
            <td>
              <ValueHelper
                      :value="item.price"
              />
            </td>
            <td>
              <ValueHelper
                      :value="item.name"
              />
            </td>
            <td>
              <ValueHelper
                      :value="item.shipping"
              />
            </td>

            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_edit.localization_value.value')"
                            :type="'edit'"
                            @click.native="changeShippingInsurancesPopup(true, item.id)"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getShippingInsurances"
                 :key="index"
            >
              <ShippingInsurancesTableMobile
                      :item="item"
                      @changeShippingInsurancesPopup="changeShippingInsurancesPopup(true, item.id)"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getShippingInsurancesCommonList.next_page_url !== null && $store.getters.getShippingInsurances.length > 0"
                    @click.native="$emit('showMore')"
                    :count="$store.getters.getShippingInsurancesCommonList.total - $store.getters.getShippingInsurancesForPage < $store.getters.getShippingInsurancesForPage ?
                    $store.getters.getShippingInsurancesCommonList.total - $store.getters.getShippingInsurancesForPage:
                    $store.getters.getShippingInsurancesForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getShippingInsurancesLoading === false && $store.getters.getShippingInsurances.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <ShippingInsurancesPopup
            v-if="isModalShippingInsurancesPopup"
            :itemId="itemId"
            :type="'update'"
            @reload="$emit('reload')"
            @close="changeShippingInsurancesPopup(false)"
    />
  </div>
</template>

<script>
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import ShippingInsurancesPopup from "../../../../popups/ShippingInsurancesPopup/ShippingInsurancesPopup";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import ShippingInsurancesTableMobile from "./ShippingInsurancesTableMobile/ShippingInsurancesTableMobile";
  import ValueHelper from "../../../../../../coreComponents/ValueHelper/ValueHelper";

  export default {
    name: "ShippingInsurancesTable",
    components: {
      ValueHelper,
      ShippingInsurancesTableMobile,
      NoResult,
      ManagerButton,
      LinkButton,
      ShowMore,
      ShippingInsurancesPopup,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalShippingInsurancesPopup: false,

      }
    },

    methods: {
      changeShippingInsurancesPopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalShippingInsurancesPopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteShippingInsurances', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
